module.exports = new __parcel__URL__("Kanban.8d42db93.svg").toString();